import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectCommercialOwnerWidgetTitle } from '../../../../selectors/abExperiments/selectCommercialOwnerWidgetTitle';

import { AboutBlock as Component, IAboutBlock } from './AboutBlock';

type TAboutBlockContainerProps = Omit<IAboutBlock, 'title'>;

export const AboutBlock: React.FC<TAboutBlockContainerProps> = props => {
  const experimentGroupName = useSelector(selectCommercialOwnerWidgetTitle);

  const title = (() => {
    switch (experimentGroupName) {
      case 'official_title':
        return 'Подтвердите право на собственность';

      case 'unofficial_title':
      default:
        return 'Подсветите объявление — станьте проверенным собственником';
    }
  })();

  return <Component {...props} title={title} />;
};

AboutBlock.displayName = 'AboutBlock';
